import Bar from "../Bar";
import Clock from "../Clock";
import Logo from "../Logo";
import InfoButton from "../buttons/InfoButton";
import SoundButton from "../buttons/SoundButton";
import BankButton from "../buttons/BankButton";
import HomeButton from "../buttons/HomeButton";
import UserButton from "../buttons/UserButton";
import InfoLabel from "../labels/InfoLabel";
import FunPlayLabel from "../labels/FunPlayLabel";
import EngineInfo from "../labels/EngineInfo";
import classes from "../../styles/Bar.module.css";
import { useAppSelector } from "../../hooks";
import { getClasses } from "../../utils";
import { FREE_MODE_CURRENCY, MaxWin } from "../../commander/Types";

import Title from "../Title";
import FullscreenButton from "../buttons/FullscreenButton";

const TopBar: React.FC = () => {
  const { currency, maxWin } = useAppSelector((state) => state.details);
  const isFunPlay = currency.code === FREE_MODE_CURRENCY;
  const isFull = maxWin || isFunPlay;
  const barClass = isFull ? "full" : "";

  return (
    <Bar className={getClasses(classes, barClass, "landscape-top")}>
      <InfoLabel shape={isFull ? "rectangle" : "trapezoid"} className="logo">
        <Logo className="landscape" />
        <Clock className="landscape" />
      </InfoLabel>
      <FunPlayLabel visible={isFunPlay} />
      <Title visible={maxWin === MaxWin.Germany && !isFunPlay} />
      <EngineInfo visible={maxWin === MaxWin.Germany} />
      <div className={getClasses(classes, "landscape-buttons-controls")}>
        <InfoButton />
        <BankButton />
        <HomeButton />
        <UserButton />
        <SoundButton />
        <FullscreenButton />
      </div>
    </Bar>
  );
};

export default TopBar;
